import uniqBy from "lodash/uniqBy";

import { createReducer } from "../../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../../generic/redux/TypedRedux";

import type { SetLastSelectedDynamicInterval, timestampAddedToHistory } from "./TimelineActions";
import { SET_LAST_SELECTED_DYNAMIC_INTERVAL, TIMESTAMP_ADDED_TO_HISTORY } from "./TimelineActionTypes";
import { type TimelineState, initialTimelineState } from "./TimelineState";
import { isStaticTimeRange } from "./TimeRange";

const RECENTLY_USED_LIST_LENGTH = 7;

function setLastSelectedDynamicInterval(state: TimelineState, { time }: SetLastSelectedDynamicInterval): TimelineState {
	if (isStaticTimeRange(time)) {
		return {
			...state,
			lastSelectedDynamicInterval: time,
		};
	}
	return {
		...state,
	};
}

function updateTimestampHistory(
	state: TimelineState,
	{ payload: { timestamp } }: ReturnType<typeof timestampAddedToHistory>,
): TimelineState {
	if (!timestamp) {
		return { ...state };
	}
	const newHistory = [timestamp].concat(state.timestampHistory);
	const timestampHistory = uniqBy(newHistory, (ts: number) => ts).slice(0, RECENTLY_USED_LIST_LENGTH);

	return {
		...state,
		timestampHistory,
	};
}

export const TimelineReducer = createReducer<TimelineState>(initialTimelineState, {
	...pairActionTypeToReducer(SET_LAST_SELECTED_DYNAMIC_INTERVAL, setLastSelectedDynamicInterval),
	[TIMESTAMP_ADDED_TO_HISTORY]: updateTimestampHistory,
});
